import firebase from "firebase/app";
import "firebase/auth";
require("firebase/firestore");
import "firebase/storage";
var firebaseConfig = {
    apiKey: "AIzaSyBFKJewJRyOl4elv-G2Ceid3EcRfeYuc4M",
    authDomain: "chennai-hydro-maatics.firebaseapp.com",
    projectId: "chennai-hydro-maatics",
    storageBucket: "chennai-hydro-maatics.appspot.com",
    messagingSenderId: "1087601424680",
    appId: "1:1087601424680:web:86c341fd8e42d7fd67f81d",
    measurementId: "G-MZY35KX62N",
};

var fb = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
export { fb, db };